import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getRecordInfo, setToSinIn } from "@/api/overseasChinese/overseasChinese";
export default {
  props: {
    editData: {
      type: Object,
      required: true
    }
  },
  components: {},
  data: function data() {
    return {
      dataInfo: {},
      formValidate: {
        classrooms: "",
        courseName: "",
        date: "",
        classTime: "",
        knob: "",
        weizhi: "",
        statusName: "",
        typeName: "",
        attendanceTime: "",
        remark: ""
      },
      // 表单数据绑定
      dialogVisible: false,
      remark: ""
    };
  },
  watch: {
    "editData.state": {
      //深度监听，可监听到对象、数组的变化
      handler: function handler(val, oldVal) {
        var arr = this.editData.data.timeRange.split("-");
        this.editData.data.startTime = this.editData.data.date + " " + arr[0];
        this.editData.data.endTime = this.editData.data.date + " " + arr[1];
        this.getEditData();
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    getEditData: function getEditData() {
      var _this = this;

      var data = this.editData.data;
      var params = {
        day: data.day || "",
        pkteachclassid: data.pkteachclassid || "",
        semesterId: data.termid || "",
        timeType: data.timeType || "",
        week: data.week || ""
      };
      getRecordInfo(params).then(function (res) {
        if (res.data.code == "0") {
          var _data = res.data.data;
          _this.dataInfo = res.data.data;
          _this.formValidate = Object.assign(_this.formValidate, _data);
          _this.formValidate.weizhi = _data.status == 4 ? "无" : _data.classrooms;
          _this.formValidate.statusName = _data.status == 1 ? "正常" : _data.status == 2 ? "迟到" : _data.status == 3 ? "早退" : "缺勤";
          _this.formValidate.typeName = _data.type == "1" ? "手工" : "扫码";
        } else {
          _this.$message.warning(res.data.msg || "获取信息失败!");
        }
      });
    },
    closeModal: function closeModal() {
      this.$emit("closeEdit", {
        state: false
      });
      this.editData.state = false;
    },
    submitForm: function submitForm() {
      this.dialogVisible = true;
    },
    submit: function submit() {
      var _this2 = this;

      var editData = this.editData.data;
      var params = {
        status: "5",
        classroomId: this.dataInfo.classroomId || "",
        classrooms: this.dataInfo.classrooms || "",
        courseId: this.dataInfo.courseid || "",
        courseName: this.dataInfo.courseName || "",
        date: this.dataInfo.date || "",
        day: editData.day || "",
        endTime: editData.endTime || "",
        startTime: editData.startTime || "",
        knob: editData.knob || "",
        pkteachclassid: editData.pkteachclassid || "",
        remark: this.remark || "",
        termid: editData.termid || "",
        timeType: editData.timeType || "",
        type: this.dataInfo.type || "",
        week: editData.week || ""
      };
      setToSinIn(params).then(function (res) {
        if (res.data.code == "0") {
          _this2.$message.success("补签成功!");

          _this2.dialogVisible = false;

          _this2.getEditData();
        } else {
          _this2.$message.warning(res.data.msg || "补签失败!");
        }
      });
    },
    closeR: function closeR() {
      this.dialogVisible = false;

      for (var _i = 0, _Object$keys = Object.keys(this.formValidate); _i < _Object$keys.length; _i++) {
        var item = _Object$keys[_i];
        this.formValidate[item] = "";
      }
    }
  }
};